export const GOOGLE_API_KEY = 'AIzaSyDBcD2pMdv07ahyM1zgQwsqqPh1YB1NEqU';
